"use client";

import { ANDROID_APP_URL, detectDeviceOS, getAppStoreUrl } from "@/lib/appLinks";

// Defaults to the Play Store link at render time (stable for SSR/hydration)
// and swaps to the right store on click, based on the visiting device —
// avoids a hydration mismatch from detecting the OS during render.
export function DownloadAppLink({
  children,
  className,
  onClick,
  "aria-label": ariaLabel,
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  "aria-label"?: string;
}) {
  return (
    <a
      href={ANDROID_APP_URL}
      onClick={(event) => {
        event.currentTarget.href = getAppStoreUrl(detectDeviceOS());
        onClick?.();
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label={ariaLabel}
    >
      {children}
    </a>
  );
}
